import { AssetCategoryResult } from '@/types/AssetCategoryResult';

export const getProductDefaultPrice = (
  product: AssetCategoryResult | undefined
) => product?.rates.normal || product?.rates.heavyUse || 0;

export const getProductStudentPrice = (
  productRates: AssetCategoryResult['rates'] | undefined
) => !!productRates?.student && productRates?.normal !== productRates?.student;
